import React, { useMemo } from 'react';
import { Row, Col } from '@dex/bubl-dash/src/lib/components/Layout/Layout';
import Panel from '@dex/bubl-dash/src/lib/components/Panel/Panel';
import MetaTable from '@dex/bubl-dash/src/lib/components/MetaTable/MetaTable';
import ActivityPanel from '@dex/bubl-dash/src/lib/components/SinglePanels/ActivityPanel';
import WebLink from '../../../components/WebLink/WebLink';

const PageSingleView: React.FC<any> = (props: any) => {

    const { data } = props;

    return useMemo(() => (

        <Row
            gutter={'auto'}
        >

            <WebLink
                path={`/${data.slug}`}
            />

            <Col
                className={'main'}
            >

                <Panel
                    heading={"Page Details"}
                >

                    <MetaTable
                        data={data}
                        columnA={[
                            {
                                label: 'Title',
                                key: 'title'
                            },
                            {
                                label: 'Slug',
                                key: 'slug'
                            },
                            {
                                label: 'Short Descripton',
                                key: 'description'
                            },
                        ]}
                        columnB={[

                        ]}
                        columnC={[
                            {
                                label: "Created On",
                                key: "created",
                                format: "onAndBy",
                            }
                        ]}
                    />

                </Panel>

            </Col>

            <Col className={'side'}>

                <ActivityPanel parent={data} />

            </Col>

        </Row>

    ), [data]);

}

export default PageSingleView;
